import { GdInputsModule } from '../inputs/fields/gd-inputs-module';
import { GdPipesModule } from '../pipes/gd-pipes-module';

import { CmnHeaderComponent } from './header/cmn-header.component';
import { CommonModule } from '@angular/common';

import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {CmnPageTitleComponent} from "./page-title/cmn-page-title.component";
import {CmnMessageComponent} from "./message/cmn-message.component";
import {CmnFooterComponent} from "./footer/cmn-footer.component";
import {CmnLinkedTextComponent} from "./linked-text/cmn-linked-text.component";
import {CmnFocusOnFieldDirective} from "./focusOnField/cmn-focus-on-field.directive";
import {EfastTableSortableComponent} from "./efast/table-sortable/efast-table-sortable.component";
import {EfastBreadcrumbComponent} from "./efast/breadcrumb/efast-breadcrumb.component";
import {EfastFilterComponent} from "./efast/filter/efast-filter.component";
import {EfastFilterPlanYearComponent} from "./efast/filter-plan-year/efast-filter-plan-year.component";
import {EfastFilterDefinedBenefitComponent} from "./efast/filter-defined-benefit/efast-filter-defined-benefit.component";
import {EfastFilterOtherPensionComponent} from "./efast/filter-other-pension/efast-filter-other-pension.component";
import {EfastFilterFilterWelfareComponent} from "./efast/filter-welfare/efast-filter-welfare.component";
import {EfastFilterAssetsComponent} from "./efast/filter-assets/efast-filter-assets.component";
import {EfastFilterParticipantsComponent} from "./efast/filter-participants/efast-filter-participants.component";
import {EfastFilterEmployerComponent} from "./efast/filter-employer/efast-filter-employer.component";
import {EfastFilterBusinessComponent} from "./efast/filter-business/efast-filter-business.component";
import {EfastFilterStatesComponent} from "./efast/filter-states/efast-filter-states.component";
import {EfastFilterForeignComponent} from "./efast/filter-foreign/efast-filter-foreign.component";
import {EfastFilterFormYearComponent} from "./efast/filter-form-year/efast-filter-form-year.component";
import {EfastFilterZipcodeComponent} from "./efast/filter-zipcode/efast-filter-zipcode.component";
import {EfastFilterDefinedContributionComponent} from "./efast/filter-defined-contribution/efast-filter-defined-contribution.component";
import {EfastPaginatorComponent} from "./efast/paginator/efast-paginator.component";
import {EfastModalProcessingComponent} from "./efast/modal-processing/efast-modal-processing.component";
import {EfastModalNotFoundComponent} from "./efast/modal-not-found/efast-modal-not-found.component";
import {EfastModalErrorComponent} from "./efast/modal-error/efast-modal-error.component";

/**
 * This module should have template components that are not used by the application modules.
 */
@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		GdPipesModule,
		GdInputsModule
	],
	declarations: [
		CmnHeaderComponent,
		CmnFooterComponent,
		CmnPageTitleComponent,
		CmnMessageComponent,
		CmnLinkedTextComponent,
		EfastTableSortableComponent,
		EfastBreadcrumbComponent,
		EfastFilterComponent,
		EfastFilterPlanYearComponent,
		EfastFilterDefinedBenefitComponent,
		EfastFilterDefinedContributionComponent,
		EfastFilterOtherPensionComponent,
		EfastFilterFilterWelfareComponent,
		EfastFilterAssetsComponent,
		EfastFilterParticipantsComponent,
		EfastFilterEmployerComponent,
		EfastFilterBusinessComponent,
		EfastFilterStatesComponent,
		EfastFilterForeignComponent,
		EfastFilterZipcodeComponent,
		EfastFilterFormYearComponent,
		EfastPaginatorComponent,
		EfastModalProcessingComponent,
		EfastModalNotFoundComponent,
		EfastModalErrorComponent,
		CmnFocusOnFieldDirective

	],
	exports: [
		CmnHeaderComponent,
		CmnFooterComponent,
		CmnPageTitleComponent,
		CmnMessageComponent,
		CmnLinkedTextComponent,
		EfastTableSortableComponent,
		EfastBreadcrumbComponent,
		EfastFilterComponent,
		EfastFilterPlanYearComponent,
		EfastFilterDefinedBenefitComponent,
		EfastFilterDefinedContributionComponent,
		EfastFilterOtherPensionComponent,
		EfastFilterFilterWelfareComponent,
		EfastFilterAssetsComponent,
		EfastFilterParticipantsComponent,
		EfastFilterEmployerComponent,
		EfastFilterBusinessComponent,
		EfastFilterStatesComponent,
		EfastFilterForeignComponent,
		EfastFilterZipcodeComponent,
		EfastFilterFormYearComponent,
		EfastPaginatorComponent,
		EfastModalProcessingComponent,
		EfastModalNotFoundComponent,
		EfastModalErrorComponent,
		CmnFocusOnFieldDirective
	]
})
export class CmnTemplatesModule { }
